module.exports = __webpack_public_path__ + "media/assets/images/blog/away-technician-small-b5d1652dd5394aa1c7f625a50c02014a.jpg";